import { render, staticRenderFns } from "./dashboardImportaciones.vue?vue&type=template&id=2afba2e1&scoped=true&"
import script from "./dashboardImportaciones.vue?vue&type=script&lang=js&"
export * from "./dashboardImportaciones.vue?vue&type=script&lang=js&"
import style0 from "./dashboardImportaciones.vue?vue&type=style&index=0&id=2afba2e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afba2e1",
  null
  
)

export default component.exports